import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUser } from "../Utils/Redux/UserSlice";
import cogoToast from 'cogo-toast-react-17-fix';

const AutoRefreshToken = (refreshTokenEndpoint) => {
  const dispatch = useDispatch();
  const User = useSelector(state => state.User);
  const { access_token, refresh_token } = User;
  const [accessToken, setAccessToken] = useState(access_token);

  const refreshAccessToken = async () => {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    };
    try {
      const response = await fetch(`${refreshTokenEndpoint}${refresh_token}`, requestOptions);
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      const data = await response.json();
      if (data.status === 200) {
        setAccessToken(data.data.access_token);
        dispatch(updateUser({ 
          access_token: data.data.access_token,
          refresh_token: data.data.refresh_token,
          expiry_time: data.data.expiry_time
        }));
      } else {
        cogoToast.info("Token refresh failed. Please check your session.");
      }
    } catch (error) {
      cogoToast.info('Refresh token error:', error);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(refreshAccessToken, 1200000); // Refresh token every 10 minutes
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  return accessToken;
};

export default AutoRefreshToken;
